/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as R403RouteImport } from './routes/403'
import { Route as VendorRouteRouteImport } from './routes/vendor/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VendorIndexRouteImport } from './routes/vendor/index'
import { Route as VendorSuratPeringatanRouteImport } from './routes/vendor/surat-peringatan'
import { Route as VendorPenjualanRouteImport } from './routes/vendor/penjualan'
import { Route as VendorPencairanRouteImport } from './routes/vendor/pencairan'
import { Route as VendorNotifikasiRouteImport } from './routes/vendor/notifikasi'
import { Route as VendorLoginRouteImport } from './routes/vendor/login'
import { Route as VendorLengkapiDataRouteImport } from './routes/vendor/lengkapi-data'
import { Route as VendorKontrakRouteImport } from './routes/vendor/kontrak'
import { Route as VendorKitRouteImport } from './routes/vendor/kit'
import { Route as VendorBerandaRouteImport } from './routes/vendor/beranda'
import { Route as VendorAkunRouteImport } from './routes/vendor/akun'
import { Route as VendorConsignmentVendorProductRouteRouteImport } from './routes/vendor/consignment-vendor-product/route'
import { Route as VendorConsignmentStockOutRouteRouteImport } from './routes/vendor/consignment-stock-out/route'
import { Route as VendorConsignmentStockInRequestRouteRouteImport } from './routes/vendor/consignment-stock-in-request/route'
import { Route as VendorStockOutIndexRouteImport } from './routes/vendor/stock-out/index'
import { Route as VendorStockInIndexRouteImport } from './routes/vendor/stock-in/index'
import { Route as VendorProdukIndexRouteImport } from './routes/vendor/produk/index'
import { Route as VendorKartuStokIndexRouteImport } from './routes/vendor/kartu-stok/index'
import { Route as VendorDashboardIndexRouteImport } from './routes/vendor/dashboard/index'
import { Route as VendorConsignmentWarningLetterIndexRouteImport } from './routes/vendor/consignment-warning-letter/index'
import { Route as VendorConsignmentVendorIndexRouteImport } from './routes/vendor/consignment-vendor/index'
import { Route as VendorConsignmentVendorSalesIndexRouteImport } from './routes/vendor/consignment-vendor-sales/index'
import { Route as VendorConsignmentVendorProductIndexRouteImport } from './routes/vendor/consignment-vendor-product/index'
import { Route as VendorConsignmentVendorApplicationIndexRouteImport } from './routes/vendor/consignment-vendor-application/index'
import { Route as VendorConsignmentStockOutIndexRouteImport } from './routes/vendor/consignment-stock-out/index'
import { Route as VendorConsignmentStockLedgerIndexRouteImport } from './routes/vendor/consignment-stock-ledger/index'
import { Route as VendorConsignmentStockInRequestIndexRouteImport } from './routes/vendor/consignment-stock-in-request/index'
import { Route as VendorConsignmentNotificationIndexRouteImport } from './routes/vendor/consignment-notification/index'
import { Route as VendorConsignmentDisbursementIndexRouteImport } from './routes/vendor/consignment-disbursement/index'
import { Route as VendorStockOutStockOutIdRouteImport } from './routes/vendor/stock-out/$stockOutId'
import { Route as VendorStockInBaruRouteImport } from './routes/vendor/stock-in/baru'
import { Route as VendorStockInStockInIdRouteImport } from './routes/vendor/stock-in/$stockInId'
import { Route as VendorProdukProductIdRouteImport } from './routes/vendor/produk/$productId'
import { Route as VendorConsignmentVendorApplicationUpdateRouteImport } from './routes/vendor/consignment-vendor-application/update'
import { Route as VendorConsignmentVendorApplicationContractRouteImport } from './routes/vendor/consignment-vendor-application/contract'
import { Route as VendorConsignmentStockInRequestCreateRouteImport } from './routes/vendor/consignment-stock-in-request/create'
import { Route as VendorConsignmentVendorProductIdDetailRouteImport } from './routes/vendor/consignment-vendor-product/$id/detail'
import { Route as VendorConsignmentStockOutIdDetailRouteImport } from './routes/vendor/consignment-stock-out/$id/detail'
import { Route as VendorConsignmentStockInRequestIdDetailRouteImport } from './routes/vendor/consignment-stock-in-request/$id/detail'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const VendorRouteRoute = VendorRouteRouteImport.update({
  id: '/vendor',
  path: '/vendor',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VendorIndexRoute = VendorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorSuratPeringatanRoute = VendorSuratPeringatanRouteImport.update({
  id: '/surat-peringatan',
  path: '/surat-peringatan',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorPenjualanRoute = VendorPenjualanRouteImport.update({
  id: '/penjualan',
  path: '/penjualan',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorPencairanRoute = VendorPencairanRouteImport.update({
  id: '/pencairan',
  path: '/pencairan',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorNotifikasiRoute = VendorNotifikasiRouteImport.update({
  id: '/notifikasi',
  path: '/notifikasi',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorLoginRoute = VendorLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorLengkapiDataRoute = VendorLengkapiDataRouteImport.update({
  id: '/lengkapi-data',
  path: '/lengkapi-data',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorKontrakRoute = VendorKontrakRouteImport.update({
  id: '/kontrak',
  path: '/kontrak',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorKitRoute = VendorKitRouteImport.update({
  id: '/kit',
  path: '/kit',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorBerandaRoute = VendorBerandaRouteImport.update({
  id: '/beranda',
  path: '/beranda',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorAkunRoute = VendorAkunRouteImport.update({
  id: '/akun',
  path: '/akun',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorConsignmentVendorProductRouteRoute =
  VendorConsignmentVendorProductRouteRouteImport.update({
    id: '/consignment-vendor-product',
    path: '/consignment-vendor-product',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorConsignmentStockOutRouteRoute =
  VendorConsignmentStockOutRouteRouteImport.update({
    id: '/consignment-stock-out',
    path: '/consignment-stock-out',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorConsignmentStockInRequestRouteRoute =
  VendorConsignmentStockInRequestRouteRouteImport.update({
    id: '/consignment-stock-in-request',
    path: '/consignment-stock-in-request',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorStockOutIndexRoute = VendorStockOutIndexRouteImport.update({
  id: '/stock-out/',
  path: '/stock-out/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorStockInIndexRoute = VendorStockInIndexRouteImport.update({
  id: '/stock-in/',
  path: '/stock-in/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorProdukIndexRoute = VendorProdukIndexRouteImport.update({
  id: '/produk/',
  path: '/produk/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorKartuStokIndexRoute = VendorKartuStokIndexRouteImport.update({
  id: '/kartu-stok/',
  path: '/kartu-stok/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorDashboardIndexRoute = VendorDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorConsignmentWarningLetterIndexRoute =
  VendorConsignmentWarningLetterIndexRouteImport.update({
    id: '/consignment-warning-letter/',
    path: '/consignment-warning-letter/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorConsignmentVendorIndexRoute =
  VendorConsignmentVendorIndexRouteImport.update({
    id: '/consignment-vendor/',
    path: '/consignment-vendor/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorConsignmentVendorSalesIndexRoute =
  VendorConsignmentVendorSalesIndexRouteImport.update({
    id: '/consignment-vendor-sales/',
    path: '/consignment-vendor-sales/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorConsignmentVendorProductIndexRoute =
  VendorConsignmentVendorProductIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => VendorConsignmentVendorProductRouteRoute,
  } as any)
const VendorConsignmentVendorApplicationIndexRoute =
  VendorConsignmentVendorApplicationIndexRouteImport.update({
    id: '/consignment-vendor-application/',
    path: '/consignment-vendor-application/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorConsignmentStockOutIndexRoute =
  VendorConsignmentStockOutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => VendorConsignmentStockOutRouteRoute,
  } as any)
const VendorConsignmentStockLedgerIndexRoute =
  VendorConsignmentStockLedgerIndexRouteImport.update({
    id: '/consignment-stock-ledger/',
    path: '/consignment-stock-ledger/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorConsignmentStockInRequestIndexRoute =
  VendorConsignmentStockInRequestIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => VendorConsignmentStockInRequestRouteRoute,
  } as any)
const VendorConsignmentNotificationIndexRoute =
  VendorConsignmentNotificationIndexRouteImport.update({
    id: '/consignment-notification/',
    path: '/consignment-notification/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorConsignmentDisbursementIndexRoute =
  VendorConsignmentDisbursementIndexRouteImport.update({
    id: '/consignment-disbursement/',
    path: '/consignment-disbursement/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorStockOutStockOutIdRoute =
  VendorStockOutStockOutIdRouteImport.update({
    id: '/stock-out/$stockOutId',
    path: '/stock-out/$stockOutId',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorStockInBaruRoute = VendorStockInBaruRouteImport.update({
  id: '/stock-in/baru',
  path: '/stock-in/baru',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorStockInStockInIdRoute = VendorStockInStockInIdRouteImport.update({
  id: '/stock-in/$stockInId',
  path: '/stock-in/$stockInId',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorProdukProductIdRoute = VendorProdukProductIdRouteImport.update({
  id: '/produk/$productId',
  path: '/produk/$productId',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorConsignmentVendorApplicationUpdateRoute =
  VendorConsignmentVendorApplicationUpdateRouteImport.update({
    id: '/consignment-vendor-application/update',
    path: '/consignment-vendor-application/update',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorConsignmentVendorApplicationContractRoute =
  VendorConsignmentVendorApplicationContractRouteImport.update({
    id: '/consignment-vendor-application/contract',
    path: '/consignment-vendor-application/contract',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorConsignmentStockInRequestCreateRoute =
  VendorConsignmentStockInRequestCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => VendorConsignmentStockInRequestRouteRoute,
  } as any)
const VendorConsignmentVendorProductIdDetailRoute =
  VendorConsignmentVendorProductIdDetailRouteImport.update({
    id: '/$id/detail',
    path: '/$id/detail',
    getParentRoute: () => VendorConsignmentVendorProductRouteRoute,
  } as any)
const VendorConsignmentStockOutIdDetailRoute =
  VendorConsignmentStockOutIdDetailRouteImport.update({
    id: '/$id/detail',
    path: '/$id/detail',
    getParentRoute: () => VendorConsignmentStockOutRouteRoute,
  } as any)
const VendorConsignmentStockInRequestIdDetailRoute =
  VendorConsignmentStockInRequestIdDetailRouteImport.update({
    id: '/$id/detail',
    path: '/$id/detail',
    getParentRoute: () => VendorConsignmentStockInRequestRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/vendor': typeof VendorRouteRouteWithChildren
  '/403': typeof R403Route
  '/login': typeof LoginRoute
  '/vendor/consignment-stock-in-request': typeof VendorConsignmentStockInRequestRouteRouteWithChildren
  '/vendor/consignment-stock-out': typeof VendorConsignmentStockOutRouteRouteWithChildren
  '/vendor/consignment-vendor-product': typeof VendorConsignmentVendorProductRouteRouteWithChildren
  '/vendor/akun': typeof VendorAkunRoute
  '/vendor/beranda': typeof VendorBerandaRoute
  '/vendor/kit': typeof VendorKitRoute
  '/vendor/kontrak': typeof VendorKontrakRoute
  '/vendor/lengkapi-data': typeof VendorLengkapiDataRoute
  '/vendor/login': typeof VendorLoginRoute
  '/vendor/notifikasi': typeof VendorNotifikasiRoute
  '/vendor/pencairan': typeof VendorPencairanRoute
  '/vendor/penjualan': typeof VendorPenjualanRoute
  '/vendor/surat-peringatan': typeof VendorSuratPeringatanRoute
  '/vendor/': typeof VendorIndexRoute
  '/vendor/consignment-stock-in-request/create': typeof VendorConsignmentStockInRequestCreateRoute
  '/vendor/consignment-vendor-application/contract': typeof VendorConsignmentVendorApplicationContractRoute
  '/vendor/consignment-vendor-application/update': typeof VendorConsignmentVendorApplicationUpdateRoute
  '/vendor/produk/$productId': typeof VendorProdukProductIdRoute
  '/vendor/stock-in/$stockInId': typeof VendorStockInStockInIdRoute
  '/vendor/stock-in/baru': typeof VendorStockInBaruRoute
  '/vendor/stock-out/$stockOutId': typeof VendorStockOutStockOutIdRoute
  '/vendor/consignment-disbursement': typeof VendorConsignmentDisbursementIndexRoute
  '/vendor/consignment-notification': typeof VendorConsignmentNotificationIndexRoute
  '/vendor/consignment-stock-in-request/': typeof VendorConsignmentStockInRequestIndexRoute
  '/vendor/consignment-stock-ledger': typeof VendorConsignmentStockLedgerIndexRoute
  '/vendor/consignment-stock-out/': typeof VendorConsignmentStockOutIndexRoute
  '/vendor/consignment-vendor-application': typeof VendorConsignmentVendorApplicationIndexRoute
  '/vendor/consignment-vendor-product/': typeof VendorConsignmentVendorProductIndexRoute
  '/vendor/consignment-vendor-sales': typeof VendorConsignmentVendorSalesIndexRoute
  '/vendor/consignment-vendor': typeof VendorConsignmentVendorIndexRoute
  '/vendor/consignment-warning-letter': typeof VendorConsignmentWarningLetterIndexRoute
  '/vendor/dashboard': typeof VendorDashboardIndexRoute
  '/vendor/kartu-stok': typeof VendorKartuStokIndexRoute
  '/vendor/produk': typeof VendorProdukIndexRoute
  '/vendor/stock-in': typeof VendorStockInIndexRoute
  '/vendor/stock-out': typeof VendorStockOutIndexRoute
  '/vendor/consignment-stock-in-request/$id/detail': typeof VendorConsignmentStockInRequestIdDetailRoute
  '/vendor/consignment-stock-out/$id/detail': typeof VendorConsignmentStockOutIdDetailRoute
  '/vendor/consignment-vendor-product/$id/detail': typeof VendorConsignmentVendorProductIdDetailRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/login': typeof LoginRoute
  '/vendor/akun': typeof VendorAkunRoute
  '/vendor/beranda': typeof VendorBerandaRoute
  '/vendor/kit': typeof VendorKitRoute
  '/vendor/kontrak': typeof VendorKontrakRoute
  '/vendor/lengkapi-data': typeof VendorLengkapiDataRoute
  '/vendor/login': typeof VendorLoginRoute
  '/vendor/notifikasi': typeof VendorNotifikasiRoute
  '/vendor/pencairan': typeof VendorPencairanRoute
  '/vendor/penjualan': typeof VendorPenjualanRoute
  '/vendor/surat-peringatan': typeof VendorSuratPeringatanRoute
  '/vendor': typeof VendorIndexRoute
  '/vendor/consignment-stock-in-request/create': typeof VendorConsignmentStockInRequestCreateRoute
  '/vendor/consignment-vendor-application/contract': typeof VendorConsignmentVendorApplicationContractRoute
  '/vendor/consignment-vendor-application/update': typeof VendorConsignmentVendorApplicationUpdateRoute
  '/vendor/produk/$productId': typeof VendorProdukProductIdRoute
  '/vendor/stock-in/$stockInId': typeof VendorStockInStockInIdRoute
  '/vendor/stock-in/baru': typeof VendorStockInBaruRoute
  '/vendor/stock-out/$stockOutId': typeof VendorStockOutStockOutIdRoute
  '/vendor/consignment-disbursement': typeof VendorConsignmentDisbursementIndexRoute
  '/vendor/consignment-notification': typeof VendorConsignmentNotificationIndexRoute
  '/vendor/consignment-stock-in-request': typeof VendorConsignmentStockInRequestIndexRoute
  '/vendor/consignment-stock-ledger': typeof VendorConsignmentStockLedgerIndexRoute
  '/vendor/consignment-stock-out': typeof VendorConsignmentStockOutIndexRoute
  '/vendor/consignment-vendor-application': typeof VendorConsignmentVendorApplicationIndexRoute
  '/vendor/consignment-vendor-product': typeof VendorConsignmentVendorProductIndexRoute
  '/vendor/consignment-vendor-sales': typeof VendorConsignmentVendorSalesIndexRoute
  '/vendor/consignment-vendor': typeof VendorConsignmentVendorIndexRoute
  '/vendor/consignment-warning-letter': typeof VendorConsignmentWarningLetterIndexRoute
  '/vendor/dashboard': typeof VendorDashboardIndexRoute
  '/vendor/kartu-stok': typeof VendorKartuStokIndexRoute
  '/vendor/produk': typeof VendorProdukIndexRoute
  '/vendor/stock-in': typeof VendorStockInIndexRoute
  '/vendor/stock-out': typeof VendorStockOutIndexRoute
  '/vendor/consignment-stock-in-request/$id/detail': typeof VendorConsignmentStockInRequestIdDetailRoute
  '/vendor/consignment-stock-out/$id/detail': typeof VendorConsignmentStockOutIdDetailRoute
  '/vendor/consignment-vendor-product/$id/detail': typeof VendorConsignmentVendorProductIdDetailRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/vendor': typeof VendorRouteRouteWithChildren
  '/403': typeof R403Route
  '/login': typeof LoginRoute
  '/vendor/consignment-stock-in-request': typeof VendorConsignmentStockInRequestRouteRouteWithChildren
  '/vendor/consignment-stock-out': typeof VendorConsignmentStockOutRouteRouteWithChildren
  '/vendor/consignment-vendor-product': typeof VendorConsignmentVendorProductRouteRouteWithChildren
  '/vendor/akun': typeof VendorAkunRoute
  '/vendor/beranda': typeof VendorBerandaRoute
  '/vendor/kit': typeof VendorKitRoute
  '/vendor/kontrak': typeof VendorKontrakRoute
  '/vendor/lengkapi-data': typeof VendorLengkapiDataRoute
  '/vendor/login': typeof VendorLoginRoute
  '/vendor/notifikasi': typeof VendorNotifikasiRoute
  '/vendor/pencairan': typeof VendorPencairanRoute
  '/vendor/penjualan': typeof VendorPenjualanRoute
  '/vendor/surat-peringatan': typeof VendorSuratPeringatanRoute
  '/vendor/': typeof VendorIndexRoute
  '/vendor/consignment-stock-in-request/create': typeof VendorConsignmentStockInRequestCreateRoute
  '/vendor/consignment-vendor-application/contract': typeof VendorConsignmentVendorApplicationContractRoute
  '/vendor/consignment-vendor-application/update': typeof VendorConsignmentVendorApplicationUpdateRoute
  '/vendor/produk/$productId': typeof VendorProdukProductIdRoute
  '/vendor/stock-in/$stockInId': typeof VendorStockInStockInIdRoute
  '/vendor/stock-in/baru': typeof VendorStockInBaruRoute
  '/vendor/stock-out/$stockOutId': typeof VendorStockOutStockOutIdRoute
  '/vendor/consignment-disbursement/': typeof VendorConsignmentDisbursementIndexRoute
  '/vendor/consignment-notification/': typeof VendorConsignmentNotificationIndexRoute
  '/vendor/consignment-stock-in-request/': typeof VendorConsignmentStockInRequestIndexRoute
  '/vendor/consignment-stock-ledger/': typeof VendorConsignmentStockLedgerIndexRoute
  '/vendor/consignment-stock-out/': typeof VendorConsignmentStockOutIndexRoute
  '/vendor/consignment-vendor-application/': typeof VendorConsignmentVendorApplicationIndexRoute
  '/vendor/consignment-vendor-product/': typeof VendorConsignmentVendorProductIndexRoute
  '/vendor/consignment-vendor-sales/': typeof VendorConsignmentVendorSalesIndexRoute
  '/vendor/consignment-vendor/': typeof VendorConsignmentVendorIndexRoute
  '/vendor/consignment-warning-letter/': typeof VendorConsignmentWarningLetterIndexRoute
  '/vendor/dashboard/': typeof VendorDashboardIndexRoute
  '/vendor/kartu-stok/': typeof VendorKartuStokIndexRoute
  '/vendor/produk/': typeof VendorProdukIndexRoute
  '/vendor/stock-in/': typeof VendorStockInIndexRoute
  '/vendor/stock-out/': typeof VendorStockOutIndexRoute
  '/vendor/consignment-stock-in-request/$id/detail': typeof VendorConsignmentStockInRequestIdDetailRoute
  '/vendor/consignment-stock-out/$id/detail': typeof VendorConsignmentStockOutIdDetailRoute
  '/vendor/consignment-vendor-product/$id/detail': typeof VendorConsignmentVendorProductIdDetailRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/vendor'
    | '/403'
    | '/login'
    | '/vendor/consignment-stock-in-request'
    | '/vendor/consignment-stock-out'
    | '/vendor/consignment-vendor-product'
    | '/vendor/akun'
    | '/vendor/beranda'
    | '/vendor/kit'
    | '/vendor/kontrak'
    | '/vendor/lengkapi-data'
    | '/vendor/login'
    | '/vendor/notifikasi'
    | '/vendor/pencairan'
    | '/vendor/penjualan'
    | '/vendor/surat-peringatan'
    | '/vendor/'
    | '/vendor/consignment-stock-in-request/create'
    | '/vendor/consignment-vendor-application/contract'
    | '/vendor/consignment-vendor-application/update'
    | '/vendor/produk/$productId'
    | '/vendor/stock-in/$stockInId'
    | '/vendor/stock-in/baru'
    | '/vendor/stock-out/$stockOutId'
    | '/vendor/consignment-disbursement'
    | '/vendor/consignment-notification'
    | '/vendor/consignment-stock-in-request/'
    | '/vendor/consignment-stock-ledger'
    | '/vendor/consignment-stock-out/'
    | '/vendor/consignment-vendor-application'
    | '/vendor/consignment-vendor-product/'
    | '/vendor/consignment-vendor-sales'
    | '/vendor/consignment-vendor'
    | '/vendor/consignment-warning-letter'
    | '/vendor/dashboard'
    | '/vendor/kartu-stok'
    | '/vendor/produk'
    | '/vendor/stock-in'
    | '/vendor/stock-out'
    | '/vendor/consignment-stock-in-request/$id/detail'
    | '/vendor/consignment-stock-out/$id/detail'
    | '/vendor/consignment-vendor-product/$id/detail'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/403'
    | '/login'
    | '/vendor/akun'
    | '/vendor/beranda'
    | '/vendor/kit'
    | '/vendor/kontrak'
    | '/vendor/lengkapi-data'
    | '/vendor/login'
    | '/vendor/notifikasi'
    | '/vendor/pencairan'
    | '/vendor/penjualan'
    | '/vendor/surat-peringatan'
    | '/vendor'
    | '/vendor/consignment-stock-in-request/create'
    | '/vendor/consignment-vendor-application/contract'
    | '/vendor/consignment-vendor-application/update'
    | '/vendor/produk/$productId'
    | '/vendor/stock-in/$stockInId'
    | '/vendor/stock-in/baru'
    | '/vendor/stock-out/$stockOutId'
    | '/vendor/consignment-disbursement'
    | '/vendor/consignment-notification'
    | '/vendor/consignment-stock-in-request'
    | '/vendor/consignment-stock-ledger'
    | '/vendor/consignment-stock-out'
    | '/vendor/consignment-vendor-application'
    | '/vendor/consignment-vendor-product'
    | '/vendor/consignment-vendor-sales'
    | '/vendor/consignment-vendor'
    | '/vendor/consignment-warning-letter'
    | '/vendor/dashboard'
    | '/vendor/kartu-stok'
    | '/vendor/produk'
    | '/vendor/stock-in'
    | '/vendor/stock-out'
    | '/vendor/consignment-stock-in-request/$id/detail'
    | '/vendor/consignment-stock-out/$id/detail'
    | '/vendor/consignment-vendor-product/$id/detail'
  id:
    | '__root__'
    | '/'
    | '/vendor'
    | '/403'
    | '/login'
    | '/vendor/consignment-stock-in-request'
    | '/vendor/consignment-stock-out'
    | '/vendor/consignment-vendor-product'
    | '/vendor/akun'
    | '/vendor/beranda'
    | '/vendor/kit'
    | '/vendor/kontrak'
    | '/vendor/lengkapi-data'
    | '/vendor/login'
    | '/vendor/notifikasi'
    | '/vendor/pencairan'
    | '/vendor/penjualan'
    | '/vendor/surat-peringatan'
    | '/vendor/'
    | '/vendor/consignment-stock-in-request/create'
    | '/vendor/consignment-vendor-application/contract'
    | '/vendor/consignment-vendor-application/update'
    | '/vendor/produk/$productId'
    | '/vendor/stock-in/$stockInId'
    | '/vendor/stock-in/baru'
    | '/vendor/stock-out/$stockOutId'
    | '/vendor/consignment-disbursement/'
    | '/vendor/consignment-notification/'
    | '/vendor/consignment-stock-in-request/'
    | '/vendor/consignment-stock-ledger/'
    | '/vendor/consignment-stock-out/'
    | '/vendor/consignment-vendor-application/'
    | '/vendor/consignment-vendor-product/'
    | '/vendor/consignment-vendor-sales/'
    | '/vendor/consignment-vendor/'
    | '/vendor/consignment-warning-letter/'
    | '/vendor/dashboard/'
    | '/vendor/kartu-stok/'
    | '/vendor/produk/'
    | '/vendor/stock-in/'
    | '/vendor/stock-out/'
    | '/vendor/consignment-stock-in-request/$id/detail'
    | '/vendor/consignment-stock-out/$id/detail'
    | '/vendor/consignment-vendor-product/$id/detail'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  VendorRouteRoute: typeof VendorRouteRouteWithChildren
  R403Route: typeof R403Route
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendor': {
      id: '/vendor'
      path: '/vendor'
      fullPath: '/vendor'
      preLoaderRoute: typeof VendorRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendor/': {
      id: '/vendor/'
      path: '/'
      fullPath: '/vendor/'
      preLoaderRoute: typeof VendorIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/surat-peringatan': {
      id: '/vendor/surat-peringatan'
      path: '/surat-peringatan'
      fullPath: '/vendor/surat-peringatan'
      preLoaderRoute: typeof VendorSuratPeringatanRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/penjualan': {
      id: '/vendor/penjualan'
      path: '/penjualan'
      fullPath: '/vendor/penjualan'
      preLoaderRoute: typeof VendorPenjualanRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/pencairan': {
      id: '/vendor/pencairan'
      path: '/pencairan'
      fullPath: '/vendor/pencairan'
      preLoaderRoute: typeof VendorPencairanRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/notifikasi': {
      id: '/vendor/notifikasi'
      path: '/notifikasi'
      fullPath: '/vendor/notifikasi'
      preLoaderRoute: typeof VendorNotifikasiRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/login': {
      id: '/vendor/login'
      path: '/login'
      fullPath: '/vendor/login'
      preLoaderRoute: typeof VendorLoginRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/lengkapi-data': {
      id: '/vendor/lengkapi-data'
      path: '/lengkapi-data'
      fullPath: '/vendor/lengkapi-data'
      preLoaderRoute: typeof VendorLengkapiDataRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/kontrak': {
      id: '/vendor/kontrak'
      path: '/kontrak'
      fullPath: '/vendor/kontrak'
      preLoaderRoute: typeof VendorKontrakRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/kit': {
      id: '/vendor/kit'
      path: '/kit'
      fullPath: '/vendor/kit'
      preLoaderRoute: typeof VendorKitRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/beranda': {
      id: '/vendor/beranda'
      path: '/beranda'
      fullPath: '/vendor/beranda'
      preLoaderRoute: typeof VendorBerandaRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/akun': {
      id: '/vendor/akun'
      path: '/akun'
      fullPath: '/vendor/akun'
      preLoaderRoute: typeof VendorAkunRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/consignment-vendor-product': {
      id: '/vendor/consignment-vendor-product'
      path: '/consignment-vendor-product'
      fullPath: '/vendor/consignment-vendor-product'
      preLoaderRoute: typeof VendorConsignmentVendorProductRouteRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/consignment-stock-out': {
      id: '/vendor/consignment-stock-out'
      path: '/consignment-stock-out'
      fullPath: '/vendor/consignment-stock-out'
      preLoaderRoute: typeof VendorConsignmentStockOutRouteRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/consignment-stock-in-request': {
      id: '/vendor/consignment-stock-in-request'
      path: '/consignment-stock-in-request'
      fullPath: '/vendor/consignment-stock-in-request'
      preLoaderRoute: typeof VendorConsignmentStockInRequestRouteRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/stock-out/': {
      id: '/vendor/stock-out/'
      path: '/stock-out'
      fullPath: '/vendor/stock-out'
      preLoaderRoute: typeof VendorStockOutIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/stock-in/': {
      id: '/vendor/stock-in/'
      path: '/stock-in'
      fullPath: '/vendor/stock-in'
      preLoaderRoute: typeof VendorStockInIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/produk/': {
      id: '/vendor/produk/'
      path: '/produk'
      fullPath: '/vendor/produk'
      preLoaderRoute: typeof VendorProdukIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/kartu-stok/': {
      id: '/vendor/kartu-stok/'
      path: '/kartu-stok'
      fullPath: '/vendor/kartu-stok'
      preLoaderRoute: typeof VendorKartuStokIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/dashboard/': {
      id: '/vendor/dashboard/'
      path: '/dashboard'
      fullPath: '/vendor/dashboard'
      preLoaderRoute: typeof VendorDashboardIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/consignment-warning-letter/': {
      id: '/vendor/consignment-warning-letter/'
      path: '/consignment-warning-letter'
      fullPath: '/vendor/consignment-warning-letter'
      preLoaderRoute: typeof VendorConsignmentWarningLetterIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/consignment-vendor/': {
      id: '/vendor/consignment-vendor/'
      path: '/consignment-vendor'
      fullPath: '/vendor/consignment-vendor'
      preLoaderRoute: typeof VendorConsignmentVendorIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/consignment-vendor-sales/': {
      id: '/vendor/consignment-vendor-sales/'
      path: '/consignment-vendor-sales'
      fullPath: '/vendor/consignment-vendor-sales'
      preLoaderRoute: typeof VendorConsignmentVendorSalesIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/consignment-vendor-product/': {
      id: '/vendor/consignment-vendor-product/'
      path: '/'
      fullPath: '/vendor/consignment-vendor-product/'
      preLoaderRoute: typeof VendorConsignmentVendorProductIndexRouteImport
      parentRoute: typeof VendorConsignmentVendorProductRouteRoute
    }
    '/vendor/consignment-vendor-application/': {
      id: '/vendor/consignment-vendor-application/'
      path: '/consignment-vendor-application'
      fullPath: '/vendor/consignment-vendor-application'
      preLoaderRoute: typeof VendorConsignmentVendorApplicationIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/consignment-stock-out/': {
      id: '/vendor/consignment-stock-out/'
      path: '/'
      fullPath: '/vendor/consignment-stock-out/'
      preLoaderRoute: typeof VendorConsignmentStockOutIndexRouteImport
      parentRoute: typeof VendorConsignmentStockOutRouteRoute
    }
    '/vendor/consignment-stock-ledger/': {
      id: '/vendor/consignment-stock-ledger/'
      path: '/consignment-stock-ledger'
      fullPath: '/vendor/consignment-stock-ledger'
      preLoaderRoute: typeof VendorConsignmentStockLedgerIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/consignment-stock-in-request/': {
      id: '/vendor/consignment-stock-in-request/'
      path: '/'
      fullPath: '/vendor/consignment-stock-in-request/'
      preLoaderRoute: typeof VendorConsignmentStockInRequestIndexRouteImport
      parentRoute: typeof VendorConsignmentStockInRequestRouteRoute
    }
    '/vendor/consignment-notification/': {
      id: '/vendor/consignment-notification/'
      path: '/consignment-notification'
      fullPath: '/vendor/consignment-notification'
      preLoaderRoute: typeof VendorConsignmentNotificationIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/consignment-disbursement/': {
      id: '/vendor/consignment-disbursement/'
      path: '/consignment-disbursement'
      fullPath: '/vendor/consignment-disbursement'
      preLoaderRoute: typeof VendorConsignmentDisbursementIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/stock-out/$stockOutId': {
      id: '/vendor/stock-out/$stockOutId'
      path: '/stock-out/$stockOutId'
      fullPath: '/vendor/stock-out/$stockOutId'
      preLoaderRoute: typeof VendorStockOutStockOutIdRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/stock-in/baru': {
      id: '/vendor/stock-in/baru'
      path: '/stock-in/baru'
      fullPath: '/vendor/stock-in/baru'
      preLoaderRoute: typeof VendorStockInBaruRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/stock-in/$stockInId': {
      id: '/vendor/stock-in/$stockInId'
      path: '/stock-in/$stockInId'
      fullPath: '/vendor/stock-in/$stockInId'
      preLoaderRoute: typeof VendorStockInStockInIdRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/produk/$productId': {
      id: '/vendor/produk/$productId'
      path: '/produk/$productId'
      fullPath: '/vendor/produk/$productId'
      preLoaderRoute: typeof VendorProdukProductIdRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/consignment-vendor-application/update': {
      id: '/vendor/consignment-vendor-application/update'
      path: '/consignment-vendor-application/update'
      fullPath: '/vendor/consignment-vendor-application/update'
      preLoaderRoute: typeof VendorConsignmentVendorApplicationUpdateRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/consignment-vendor-application/contract': {
      id: '/vendor/consignment-vendor-application/contract'
      path: '/consignment-vendor-application/contract'
      fullPath: '/vendor/consignment-vendor-application/contract'
      preLoaderRoute: typeof VendorConsignmentVendorApplicationContractRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/consignment-stock-in-request/create': {
      id: '/vendor/consignment-stock-in-request/create'
      path: '/create'
      fullPath: '/vendor/consignment-stock-in-request/create'
      preLoaderRoute: typeof VendorConsignmentStockInRequestCreateRouteImport
      parentRoute: typeof VendorConsignmentStockInRequestRouteRoute
    }
    '/vendor/consignment-vendor-product/$id/detail': {
      id: '/vendor/consignment-vendor-product/$id/detail'
      path: '/$id/detail'
      fullPath: '/vendor/consignment-vendor-product/$id/detail'
      preLoaderRoute: typeof VendorConsignmentVendorProductIdDetailRouteImport
      parentRoute: typeof VendorConsignmentVendorProductRouteRoute
    }
    '/vendor/consignment-stock-out/$id/detail': {
      id: '/vendor/consignment-stock-out/$id/detail'
      path: '/$id/detail'
      fullPath: '/vendor/consignment-stock-out/$id/detail'
      preLoaderRoute: typeof VendorConsignmentStockOutIdDetailRouteImport
      parentRoute: typeof VendorConsignmentStockOutRouteRoute
    }
    '/vendor/consignment-stock-in-request/$id/detail': {
      id: '/vendor/consignment-stock-in-request/$id/detail'
      path: '/$id/detail'
      fullPath: '/vendor/consignment-stock-in-request/$id/detail'
      preLoaderRoute: typeof VendorConsignmentStockInRequestIdDetailRouteImport
      parentRoute: typeof VendorConsignmentStockInRequestRouteRoute
    }
  }
}

interface VendorConsignmentStockInRequestRouteRouteChildren {
  VendorConsignmentStockInRequestCreateRoute: typeof VendorConsignmentStockInRequestCreateRoute
  VendorConsignmentStockInRequestIndexRoute: typeof VendorConsignmentStockInRequestIndexRoute
  VendorConsignmentStockInRequestIdDetailRoute: typeof VendorConsignmentStockInRequestIdDetailRoute
}

const VendorConsignmentStockInRequestRouteRouteChildren: VendorConsignmentStockInRequestRouteRouteChildren =
  {
    VendorConsignmentStockInRequestCreateRoute:
      VendorConsignmentStockInRequestCreateRoute,
    VendorConsignmentStockInRequestIndexRoute:
      VendorConsignmentStockInRequestIndexRoute,
    VendorConsignmentStockInRequestIdDetailRoute:
      VendorConsignmentStockInRequestIdDetailRoute,
  }

const VendorConsignmentStockInRequestRouteRouteWithChildren =
  VendorConsignmentStockInRequestRouteRoute._addFileChildren(
    VendorConsignmentStockInRequestRouteRouteChildren,
  )

interface VendorConsignmentStockOutRouteRouteChildren {
  VendorConsignmentStockOutIndexRoute: typeof VendorConsignmentStockOutIndexRoute
  VendorConsignmentStockOutIdDetailRoute: typeof VendorConsignmentStockOutIdDetailRoute
}

const VendorConsignmentStockOutRouteRouteChildren: VendorConsignmentStockOutRouteRouteChildren =
  {
    VendorConsignmentStockOutIndexRoute: VendorConsignmentStockOutIndexRoute,
    VendorConsignmentStockOutIdDetailRoute:
      VendorConsignmentStockOutIdDetailRoute,
  }

const VendorConsignmentStockOutRouteRouteWithChildren =
  VendorConsignmentStockOutRouteRoute._addFileChildren(
    VendorConsignmentStockOutRouteRouteChildren,
  )

interface VendorConsignmentVendorProductRouteRouteChildren {
  VendorConsignmentVendorProductIndexRoute: typeof VendorConsignmentVendorProductIndexRoute
  VendorConsignmentVendorProductIdDetailRoute: typeof VendorConsignmentVendorProductIdDetailRoute
}

const VendorConsignmentVendorProductRouteRouteChildren: VendorConsignmentVendorProductRouteRouteChildren =
  {
    VendorConsignmentVendorProductIndexRoute:
      VendorConsignmentVendorProductIndexRoute,
    VendorConsignmentVendorProductIdDetailRoute:
      VendorConsignmentVendorProductIdDetailRoute,
  }

const VendorConsignmentVendorProductRouteRouteWithChildren =
  VendorConsignmentVendorProductRouteRoute._addFileChildren(
    VendorConsignmentVendorProductRouteRouteChildren,
  )

interface VendorRouteRouteChildren {
  VendorConsignmentStockInRequestRouteRoute: typeof VendorConsignmentStockInRequestRouteRouteWithChildren
  VendorConsignmentStockOutRouteRoute: typeof VendorConsignmentStockOutRouteRouteWithChildren
  VendorConsignmentVendorProductRouteRoute: typeof VendorConsignmentVendorProductRouteRouteWithChildren
  VendorAkunRoute: typeof VendorAkunRoute
  VendorBerandaRoute: typeof VendorBerandaRoute
  VendorKitRoute: typeof VendorKitRoute
  VendorKontrakRoute: typeof VendorKontrakRoute
  VendorLengkapiDataRoute: typeof VendorLengkapiDataRoute
  VendorLoginRoute: typeof VendorLoginRoute
  VendorNotifikasiRoute: typeof VendorNotifikasiRoute
  VendorPencairanRoute: typeof VendorPencairanRoute
  VendorPenjualanRoute: typeof VendorPenjualanRoute
  VendorSuratPeringatanRoute: typeof VendorSuratPeringatanRoute
  VendorIndexRoute: typeof VendorIndexRoute
  VendorConsignmentVendorApplicationContractRoute: typeof VendorConsignmentVendorApplicationContractRoute
  VendorConsignmentVendorApplicationUpdateRoute: typeof VendorConsignmentVendorApplicationUpdateRoute
  VendorProdukProductIdRoute: typeof VendorProdukProductIdRoute
  VendorStockInStockInIdRoute: typeof VendorStockInStockInIdRoute
  VendorStockInBaruRoute: typeof VendorStockInBaruRoute
  VendorStockOutStockOutIdRoute: typeof VendorStockOutStockOutIdRoute
  VendorConsignmentDisbursementIndexRoute: typeof VendorConsignmentDisbursementIndexRoute
  VendorConsignmentNotificationIndexRoute: typeof VendorConsignmentNotificationIndexRoute
  VendorConsignmentStockLedgerIndexRoute: typeof VendorConsignmentStockLedgerIndexRoute
  VendorConsignmentVendorApplicationIndexRoute: typeof VendorConsignmentVendorApplicationIndexRoute
  VendorConsignmentVendorSalesIndexRoute: typeof VendorConsignmentVendorSalesIndexRoute
  VendorConsignmentVendorIndexRoute: typeof VendorConsignmentVendorIndexRoute
  VendorConsignmentWarningLetterIndexRoute: typeof VendorConsignmentWarningLetterIndexRoute
  VendorDashboardIndexRoute: typeof VendorDashboardIndexRoute
  VendorKartuStokIndexRoute: typeof VendorKartuStokIndexRoute
  VendorProdukIndexRoute: typeof VendorProdukIndexRoute
  VendorStockInIndexRoute: typeof VendorStockInIndexRoute
  VendorStockOutIndexRoute: typeof VendorStockOutIndexRoute
}

const VendorRouteRouteChildren: VendorRouteRouteChildren = {
  VendorConsignmentStockInRequestRouteRoute:
    VendorConsignmentStockInRequestRouteRouteWithChildren,
  VendorConsignmentStockOutRouteRoute:
    VendorConsignmentStockOutRouteRouteWithChildren,
  VendorConsignmentVendorProductRouteRoute:
    VendorConsignmentVendorProductRouteRouteWithChildren,
  VendorAkunRoute: VendorAkunRoute,
  VendorBerandaRoute: VendorBerandaRoute,
  VendorKitRoute: VendorKitRoute,
  VendorKontrakRoute: VendorKontrakRoute,
  VendorLengkapiDataRoute: VendorLengkapiDataRoute,
  VendorLoginRoute: VendorLoginRoute,
  VendorNotifikasiRoute: VendorNotifikasiRoute,
  VendorPencairanRoute: VendorPencairanRoute,
  VendorPenjualanRoute: VendorPenjualanRoute,
  VendorSuratPeringatanRoute: VendorSuratPeringatanRoute,
  VendorIndexRoute: VendorIndexRoute,
  VendorConsignmentVendorApplicationContractRoute:
    VendorConsignmentVendorApplicationContractRoute,
  VendorConsignmentVendorApplicationUpdateRoute:
    VendorConsignmentVendorApplicationUpdateRoute,
  VendorProdukProductIdRoute: VendorProdukProductIdRoute,
  VendorStockInStockInIdRoute: VendorStockInStockInIdRoute,
  VendorStockInBaruRoute: VendorStockInBaruRoute,
  VendorStockOutStockOutIdRoute: VendorStockOutStockOutIdRoute,
  VendorConsignmentDisbursementIndexRoute:
    VendorConsignmentDisbursementIndexRoute,
  VendorConsignmentNotificationIndexRoute:
    VendorConsignmentNotificationIndexRoute,
  VendorConsignmentStockLedgerIndexRoute:
    VendorConsignmentStockLedgerIndexRoute,
  VendorConsignmentVendorApplicationIndexRoute:
    VendorConsignmentVendorApplicationIndexRoute,
  VendorConsignmentVendorSalesIndexRoute:
    VendorConsignmentVendorSalesIndexRoute,
  VendorConsignmentVendorIndexRoute: VendorConsignmentVendorIndexRoute,
  VendorConsignmentWarningLetterIndexRoute:
    VendorConsignmentWarningLetterIndexRoute,
  VendorDashboardIndexRoute: VendorDashboardIndexRoute,
  VendorKartuStokIndexRoute: VendorKartuStokIndexRoute,
  VendorProdukIndexRoute: VendorProdukIndexRoute,
  VendorStockInIndexRoute: VendorStockInIndexRoute,
  VendorStockOutIndexRoute: VendorStockOutIndexRoute,
}

const VendorRouteRouteWithChildren = VendorRouteRoute._addFileChildren(
  VendorRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  VendorRouteRoute: VendorRouteRouteWithChildren,
  R403Route: R403Route,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
